module.exports = __webpack_public_path__ + "static/media/0029_IMG_LE_SOL_LEGNI_WALNUT.25ad7186.webp";